<script setup lang="ts">
import QuestionFilterButton from '@/components/Student/TestReview/QuestionFilterButton.vue';
import TestReviewStatusFilter from '@/components/Student/TestReview/TestReviewStatusFilter.vue';

defineProps<{
    submittedFilters: string[];
}>();

defineEmits<{(event: 'apply-filters', filters: string[]): void }>();

</script>
<template>
    <QuestionFilterButton :submitted-filters="submittedFilters">
        <q-menu
            class="quiz-filter-menu"
        >
            <TestReviewStatusFilter
                :applied-filters="submittedFilters"
                @apply-filters="(filters: string[]) => $emit('apply-filters', filters)"
            />
        </q-menu>
    </QuestionFilterButton>
</template>
<style scoped lang="scss">
</style>
